import { postReq } from 'src/services/http';
import { ai_prompt_count } from 'src/stores/features/ai-model';

/**
 * Gets the AI prompt token count via the cloud API and updates the store.
 * Calls POST /interface/ai/list and sets the response count to ai_prompt_count.
 */
export async function getAiPromptCount(): Promise<number | null> {
	const res = await postReq('/interface/ai/list', {}, 6000, undefined, false);

	if (!res?.isok) {
		return null;
	}

	const count = res.data?.ai?.bcc?.counter;
	if (typeof count === 'number') {
		ai_prompt_count.set(count);
		return count;
	}

	if (!res.data?.ai?.bcc?.counter) {
		ai_prompt_count.set(0);
		return 0;
	}

	ai_prompt_count.set(null);
	return null;
}
